import React from 'react';

class MultipleValidationModal extends React.Component {
    render() {
        const { idValidation, sellTypeSelection, message, shadow, idModalOrigin } = this.props;
        return (
            <div className="modal fade" id={idValidation} tabIndex="-1" role="dialog" aria-labelledby="validationModalTitle" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content" style={shadow ? { boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px" } : { boxShadow: "none" }}>
                        <div className="modal-body">
                            <h4>{message}</h4>
                        </div>
                        <div className="modal-footer">
                            {sellTypeSelection?.filter(btn => btn.active).map(btn =>
                                <button
                                    type="button"
                                    className={`btn ${btn?.style || 'btn-secondary'}`}
                                    data-dismiss="modal"
                                    data-target={idModalOrigin}
                                    data-toggle="modal"
                                    onClick={btn?.onClickEvent ?? null}
                                >
                                    {btn?.label ?? '--'}
                                </button>
                            )

                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MultipleValidationModal

